import { getPageBreadcrumbs } from '@simpledotink/notion-utils';
import React, { useState } from 'react';
import { useNotionContext } from '../context';
import { PageIcon } from './page-icon';
import { SearchDialog } from './search-dialog';
import { SearchIcon } from '../icons/search-icon';
import { cs } from '../utils';
export function NavbarComponent(_a) {
    var _b, _c, _d, _e;
    var navbar = _a.navbar;
    var _f = useNotionContext(), recordMap = _f.recordMap, components = _f.components, mapPageUrl = _f.mapPageUrl, searchNotion = _f.searchNotion, rootPageId = _f.rootPageId;
    var isSearchEnabled = !!searchNotion;
    var _g = React.useState(false), isSearchOpen = _g[0], setIsSearchOpen = _g[1];
    var onOpenSearch = React.useCallback(function () {
        setIsSearchOpen(true);
    }, []);
    var onCloseSearch = React.useCallback(function () {
        setIsSearchOpen(false);
    }, []);
    var _h = useState(false), isMenuOpen = _h[0], setIsMenuOpen = _h[1];
    var blockMap = recordMap.block;
    var blockIds = Object.keys(blockMap);
    var activePageId = blockIds[0];
    var page = getPageBreadcrumbs(recordMap, activePageId)[0];
    var PageLink = function (_a) {
        var children = _a.children;
        return (React.createElement(components.pageLink, { className: 'title-link', href: mapPageUrl(page.pageId) || '' }, children));
    };
    var defaultPageTitle = (React.createElement(PageLink, null,
        React.createElement("div", { className: 'title' },
            page.icon && React.createElement(PageIcon, { className: 'icon', block: page.block }),
            page.title && React.createElement("span", { className: 'title' }, page.title))));
    var title = defaultPageTitle;
    switch (navbar.logo_type) {
        case 'emoji':
            if (navbar.logo_emoji)
                title = (React.createElement("img", { src: navbar.logo_emoji, style: {
                        cursor: 'pointer',
                        height: "".concat(navbar.logo_size, "px"),
                        objectFit: 'cover'
                    } }));
            break;
        case 'text':
            if (navbar.logo_text)
                title = (React.createElement("p", { className: 'title', style: {
                        cursor: 'pointer'
                    } }, navbar.logo_text));
            break;
        case 'image':
            if (navbar.logo_image)
                title = (React.createElement("img", { src: navbar.logo_image, style: {
                        cursor: 'pointer',
                        height: "".concat(navbar.logo_size, "px"),
                        objectFit: 'cover'
                    } }));
    }
    title = React.createElement(PageLink, null, title);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'custom-header-container', style: navbar.is_floating
                ? {
                    position: 'sticky',
                    top: 0
                }
                : null },
            React.createElement("div", { className: 'custom-header', style: {
                    backgroundColor: (navbar === null || navbar === void 0 ? void 0 : navbar.background_color) || 'transparent',
                    minHeight: "".concat(navbar === null || navbar === void 0 ? void 0 : navbar.height, "px") || '58px',
                    color: (navbar === null || navbar === void 0 ? void 0 : navbar.color) || 'black'
                } },
                title,
                React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                    React.createElement("div", { className: 'custom-header__links' }, (_b = navbar === null || navbar === void 0 ? void 0 : navbar.links) === null || _b === void 0 ? void 0 :
                        _b.sort(function (a, b) { return a.sort_num - b.sort_num; }).map(function (link) {
                            return (React.createElement("a", { key: link.id, href: (link === null || link === void 0 ? void 0 : link.url) || '', target: link.open_in_new_tab ? '_blank' : '_self', className: 'custom-header__links__link' }, link.title));
                        }), (_c = navbar === null || navbar === void 0 ? void 0 : navbar.buttons) === null || _c === void 0 ? void 0 :
                        _c.sort(function (a, b) { return a.sort_num - b.sort_num; }).map(function (button) {
                            return (React.createElement("a", { key: button.id, href: button.link, target: button.open_in_new_tab ? '_blank' : '_self', className: 'custom-header__links__link', style: {
                                    backgroundColor: button.background_color || 'blue',
                                    color: button.text_color || 'white',
                                    borderRadius: button.shape === 'rounded-rectangle'
                                        ? '5px'
                                        : button.shape === 'rounded'
                                            ? '50%'
                                            : '0px'
                                } }, button.title));
                        })),
                    React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                        React.createElement("div", { className: 'custom-header__menu', onClick: function () {
                                console.log('hello');
                                setIsMenuOpen(function (m) { return !m; });
                            } }, !isMenuOpen ? (React.createElement("span", { className: 'icon' },
                            React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 24 24', width: 24, height: 24 },
                                React.createElement("path", { d: 'M3 4H21V6H3V4ZM3 11H21V13H3V11ZM3 18H21V20H3V18Z', fill: 'currentColor' })))) : (React.createElement("span", { className: 'icon' },
                            React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 24 24', width: 24, height: 24 },
                                React.createElement("path", { d: 'M12.0007 10.5865L16.9504 5.63672L18.3646 7.05093L13.4149 12.0007L18.3646 16.9504L16.9504 18.3646L12.0007 13.4149L7.05093 18.3646L5.63672 16.9504L10.5865 12.0007L5.63672 7.05093L7.05093 5.63672L12.0007 10.5865Z', fill: 'currentColor' }))))),
                        isSearchEnabled && (React.createElement("div", { className: 'rhs', key: 'rhs' },
                            React.createElement("div", { role: 'button', className: cs('breadcrumb', 'button', 'notion-search-button'), onClick: onOpenSearch },
                                React.createElement(SearchIcon, { className: 'searchIcon' }),
                                React.createElement("span", { className: 'title search-title ' }, "Search")),
                            React.createElement(SearchDialog, { isOpen: isSearchOpen, rootBlockId: rootPageId || activePageId, onClose: onCloseSearch, searchNotion: searchNotion }))))))),
        React.createElement("div", { className: "custom-header__mobile-links  ".concat(isMenuOpen ? 'custom-header__mobile-links--open' : '') }, (_d = navbar === null || navbar === void 0 ? void 0 : navbar.links) === null || _d === void 0 ? void 0 :
            _d.sort(function (a, b) { return b.sort_num - a.sort_num; }).map(function (link) {
                return (React.createElement("a", { key: link.id, href: link.url, target: link.open_in_new_tab ? '_blank' : '_self', className: 'custom-header__links__link', onClick: function () {
                        console.log('hi ');
                        setIsMenuOpen(false);
                    } }, link.title));
            }), (_e = navbar === null || navbar === void 0 ? void 0 : navbar.buttons) === null || _e === void 0 ? void 0 :
            _e.sort(function (a, b) { return b.sort_num - a.sort_num; }).map(function (button) {
                return (React.createElement("a", { key: button.id, href: button.link, target: button.open_in_new_tab ? '_blank' : '_self', className: 'custom-header__links__link', style: {
                        backgroundColor: button.background_color || 'blue',
                        color: button.text_color || 'white',
                        borderRadius: button.shape === 'rounded-rectangle'
                            ? '5px'
                            : button.shape === 'rounded'
                                ? '50%'
                                : '0px'
                    } }, button.title));
            }))));
}
//# sourceMappingURL=navbar-component.js.map